module.exports = __webpack_public_path__ + "img/new_point1.c687e6dd.png";